import { render, staticRenderFns } from "./_postSubmitButton.vue?vue&type=template&id=e0282796"
import script from "./_postSubmitButton.vue?vue&type=script&lang=js"
export * from "./_postSubmitButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports